module.exports = __webpack_public_path__ + "static/strip-edge-27ed1c66be78246caa6212be37d58b3c.jpg";